import { IState } from '../../store';
import { INewBuildingWithFeatures } from '../../types/newobject/newobject';

export const selectNewObject = (state: IState): INewBuildingWithFeatures | null => {
  return state.offerData.newObject;
};
